<template>
    <div class="col-md-12 px-0 py-0 mt-5">
        <form class="form-horizontal">
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Nombre</label
                >
                <div class="col-md-9">
                    <input
                        name="name"
                        type="text"
                        v-model="name"
                        class="form-control"
                        placeholder="Nombre"
                    />
                    <span v-if="allerrors.name" :class="['show-error']">{{
                        allerrors.name[0]
                    }}</span>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Enlace</label
                >
                <div class="col-md-9">
                    <input
                        name="link"
                        type="url"
                        v-model="link"
                        class="form-control"
                        placeholder="Enlace"
                    />
                    <span v-if="allerrors.link" :class="['show-error']">{{
                        allerrors.link[0]
                    }}</span>
                </div>
            </div>
            <div class="form-group row">
                <label
                    class="col-md-3 form-control-label"
                    for="text-input"
                ></label>
                <div class="col-md-9">
                    <div id="fine-uploader-manual-trigger"></div>
                    <span v-if="allerrors.image" :class="['show-error']">{{
                        allerrors.image[0]
                    }}</span>
                    <a
                        v-if="image_path"
                        :href="image_path"
                        target="_blank"
                        rel="noopener noreferrer"
                        >Ver imagen</a
                    >
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Alt image</label
                >
                <div class="col-md-9">
                    <input
                        type="text"
                        v-model="text_image_alt"
                        class="form-control"
                        placeholder="Alt image"
                    />
                    <span
                        v-if="allerrors.text_image_alt"
                        :class="['show-error']"
                        >{{ allerrors.text_image_alt[0] }}</span
                    >
                </div>
            </div>

            <div class="modal-footer">
                <button
                    v-if="model_id == 0"
                    type="button"
                    @click="create()"
                    class="btn btn-primary"
                >
                    Agregar
                </button>
                <button
                    v-if="model_id > 0"
                    type="button"
                    @click="update()"
                    class="btn btn-primary"
                >
                    Actualizar
                </button>
            </div>
        </form>
        <template-uploader></template-uploader>
    </div>
</template>
<script>
import qq from "fine-uploader";
import "fine-uploader/fine-uploader/fine-uploader-new.min.css";
export default {
    props: {
        model_id: Number,
        parent_id: Number,
    },
    data() {
        return {
            action: "",
            name: null,
            image: null,
            text_image_alt: null,

            image_path: null,
            link: null,
            allerrors: {
                name: null,
                image: null,
                link: null,
                text_image_alt: null,
            },
        };
    },
    methods: {
        getModel() {
            let me = this;
            axios
                .get("/api/contests/allies/show/" + me.model_id)
                .then(function (response) {
                    me.name = response.data.model.name;
                    me.image = response.data.model.image;
                    me.text_image_alt = response.data.model.text_image_alt;
                    me.link = response.data.model.link;
                    me.image_path = response.data.image_path;
                })
                .catch(function (error) {});
        },
        create() {
            let me = this;
            if (me.validForm()) {
                axios
                    .post(me.action, {
                        name: me.name,
                        image: me.image,
                        text_image_alt: me.text_image_alt,
                        link: me.link,
                    })
                    .then(function (response) {
                        me.allerrors = [];
                        me.showActionSuccess("Creacion exitosa!");
                        me.$emit("change");
                    })
                    .catch(function (error) {
                        if (error.response && error.response.data) {
                            me.allerrors = error.response.data.errors;
                        }
                    });
            }
        },
        update() {
            let me = this;
            if (me.validForm()) {
                axios
                    .put(me.action, {
                        name: me.name,
                        image: me.image,
                        text_image_alt: me.text_image_alt,
                        link: me.link,
                        contest_id: me.parent_id,
                    })
                    .then(function (response) {
                        me.image_path = response.data.image_path;
                        me.allerrors = [];
                        me.showActionSuccess("Actualizacion exitosa!");
                    })
                    .catch(function (error) {
                        if (error.response && error.response.data) {
                            me.allerrors = error.response.data.errors;
                        }
                    });
            }
        },
        validForm() {
            let me = this;
            let valid = true;

            if (!me.name) {
                me.allerrors.name = ["El campo nombre es obligatorio."];
                valid = false;
            } else if (me.name.length > 100) {
                me.allerrors.name = [
                    "El campo nombre debe tener máximo 100 caracteres",
                ];
                valid = false;
            } else {
                me.allerrors.name = null;
            }

            if (!me.image) {
                me.allerrors.image = ["El campo imagen es obligatorio."];
                valid = false;
            }

            if (me.text_image_alt && me.text_image_alt.length > 190) {
                me.allerrors.text_image_alt = [
                    "El campo image alt debe tener máximo 190 caracteres",
                ];
                valid = false;
            } else {
                me.allerrors.text_image_alt = null;
            }

            if (!me.link) {
                me.allerrors.link = ["El campo link es obligatorio."];
                valid = false;
            } else {
                me.allerrors.link = null;
            }
            return valid;
        },
        showActionSuccess(message) {
            const Toast = this.$swal.mixin({
                toast: true,
                icon: "success",
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
            });

            Toast.fire({
                type: "success",
                title: message,
            });
        },
        getUploadImageUrl() {
            const appUrl = document.querySelector(
                'meta[name="app-url"]'
            ).content;
            return `${appUrl}api/upload-image`;
        },
        getDeleteFileUrl() {
            const appUrl = document.querySelector(
                'meta[name="app-url"]'
            ).content;
            return `${appUrl}api/delete-file`;
        },
    },
    mounted() {
        let me = this;
        const authUserId = document.querySelector(
            'meta[name="x-user"]'
        ).content;
        if (me.model_id == 0) {
            me.action = `/api/contests/allies?contest_id=${me.parent_id}&key=${authUserId}`;
            new qq.FineUploader({
                element: document.getElementById(
                    "fine-uploader-manual-trigger"
                ),
                request: {
                    endpoint: this.getUploadImageUrl(),
                },
                deleteFile: {
                    enabled: true, // defaults to false
                    endpoint: this.getDeleteFileUrl(),
                },
                template: "qq-template-manual-trigger",
                validation: {
                    allowedExtensions: ["jpeg", "jpg", "png", "svg"],
                    itemLimit: 1,
                    sizeLimit: 20971520,
                    image: {
                        maxHeight: 90,
                        minHeight: 90,
                        maxWidth: 150,
                        minWidth: 150,
                    },
                },
                messages: {
                    noFilesError: "Seleccione una imagen.",
                    maxWidthImageError:
                        "Dimensiones incorrectas debe ser de 150x90 px.",
                    minWidthImageError:
                        "Dimensiones incorrectas debe ser de 150x90 px.",
                    maxHeightImageError:
                        "Dimensiones incorrectas debe ser de 150x90 px.",
                    minHeightImageError:
                        "Dimensiones incorrectas debe ser de 150x90 px.",
                },
                callbacks: {
                    onComplete: function (id, name, response) {
                        if (response.success) {
                            me.allerrors["image"] = null;
                            me.image = response.path;
                        } else {
                            me.allerrors["image"] = ["Error en la imagen"];
                        }
                    },
                    onDeleteComplete: function (id, name, response) {
                        me.allerrors["image"] = null;
                        me.image = "";
                    },
                },
                multiple: false,
            });
        } else {
            this.getModel();
            me.action = "/api/contests/allies/update/" + me.model_id;
            new qq.FineUploader({
                element: document.getElementById(
                    "fine-uploader-manual-trigger"
                ),
                request: {
                    endpoint: this.getUploadImageUrl(),
                },
                template: "qq-template-manual-trigger",
                validation: {
                    allowedExtensions: ["jpeg", "jpg", "png", "svg"],
                    sizeLimit: 20971520,
                    image: {
                        maxHeight: 90,
                        minHeight: 90,
                        maxWidth: 150,
                        minWidth: 150,
                    },
                },
                messages: {
                    noFilesError: "Seleccione una imagen.",
                    maxWidthImageError:
                        "Dimensiones incorrectas debe ser de 150x90 px.",
                    minWidthImageError:
                        "Dimensiones incorrectas debe ser de 150x90 px.",
                    maxHeightImageError:
                        "Dimensiones incorrectas debe ser de 150x90 px.",
                    minHeightImageError:
                        "Dimensiones incorrectas debe ser de 150x90 px.",
                },
                callbacks: {
                    onComplete: function (id, name, response) {
                        if (response.success) {
                            me.allerrors["image"] = null;
                            me.image = response.path;
                        } else {
                            me.allerrors["image"] = ["Error en la imagen"];
                        }
                    },
                },
                multiple: false,
            });
        }
    },
};
</script>
<style>
.show-error {
    display: block;
    margin-top: 0.25rem;
    font-size: 0.875rem;
    color: #f86c6b;
}
</style>
